export default {
      id: "color_sports-usage",
      viewBox: "0 0 79 56",
      url: __webpack_public_path__ + "sprite.svg#color_sports",
      toString: function () {
        return this.url;
      }
    }